"use strict";
import Notification from 'rc-notification';
import React from 'react';
import '../../css/components/Modal/notification.css';
let defaultTop = 24;
let notificationInstance;
let defaultDuration = 4.5;
function getNotificationInstance(prefixCls) {
    if (notificationInstance) {
        return notificationInstance;
    }
    notificationInstance = Notification.newInstance({
        prefixCls: prefixCls,
        style: {
            top: defaultTop,
            right: 0,
        },
    });
    return notificationInstance;
}
function notice(args) {
    const outerPrefixCls = args.prefixCls || 'sys-notification';
    const prefixCls = `${outerPrefixCls}-notice`;
    let duration;
    if (args.duration === undefined) {
        duration = defaultDuration;
    }
    else {
        duration = args.duration;
    }
    let iconType = '';
    switch (args.type) {
        case 'success':
            iconType = 'check-circle-o';
            break;
        case 'info':
            iconType = 'info-circle-o';
            break;
        case 'error':
            iconType = 'cross-circle-o';
            break;
        case 'warning':
            iconType = 'exclamation-circle-o';
            break;
        default:
            iconType = 'info-circle';
    }
    let iconNode;
    if (args.icon) {
      iconNode = (
        <span className={`${prefixCls}-icon`}>
          {args.icon}
        </span>
      );
    } else if (args.type) {
      iconNode =
      <i
        className={`${prefixCls}-icon ${prefixCls}-icon-${args.type}`}
        type={iconType} />
      ;
    }
    getNotificationInstance(outerPrefixCls).notice({
        content: (<div className={iconNode ? `${prefixCls}-with-icon` : ''}>
        {iconNode}
        <div className={`${prefixCls}-message`}>{args.message}</div>
        <div className={`${prefixCls}-description`}>{args.description}</div>
        {args.btn ? <span className={`${prefixCls}-btn`}>{args.btn}</span> : null}
      </div>),
        duration,
        closable: true,
        onClose: args.onClose,
        key: args.key,
        style: {},
    });
}
const api = {
    open(args) {
        notice(args);
    },
    close(key) {
        if (notificationInstance) {
            notificationInstance.removeNotice(key);
        }
    },
    config(options) {
        if (options.top !== undefined) {
            defaultTop = options.top;
            notificationInstance = null;
        }
        if (options.duration !== undefined) {
            defaultDuration = options.duration;
        }
    },
    destroy() {
        if (notificationInstance) {
            notificationInstance.destroy();
            notificationInstance = null;
        }
    },
};
['success', 'info', 'warning', 'error'].forEach((type) => {
    api[type] = (args) => api.open(Object.assign({}, args, { type }));
});
api.warn = api.warning;
// Object.defineProperty(exports, "__esModule", { value: true });
module.exports = api;



/** WEBPACK FOOTER **
 ** ./src/components/Modal/notification.js
 **/